export default __webpack_public_path__ + "static/media/operations-icon.1f0f8a64.svg";